module.exports = __webpack_public_path__ + "img/working-info.6399d0e6.svg";